import { Item, ItemIdentifier } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import type { operations } from '@/api/generated/openapi';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';

export type CreateInventoryItemIdentifierResponse = operations['add-inventory-item-identifier']['responses']['200']['content']['application/json'];
export type DeleteInventoryItemIdentifierResponse = operations['delete-inventory-item-identifier']['responses']['200']['content']['application/json'];
export type CreateInventoryItemIdentifierRequest = operations['add-inventory-item-identifier']['requestBody']['content']['application/json'];

export type ItemIdentifierResponse = CreateInventoryItemIdentifierResponse['identifier'];

export function toItemIdentifier(inv: ItemIdentifierResponse): ItemIdentifier {
    return {
        id: inv.id,
        identifier: inv.identifier,
        identifierType: inv.identifier_type,
    };
}

export interface createIdentifierInterface {
    identifierType: string
    identifier: string
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): { createIdentifier: (item: Pick<Item, 'id'>, payload: createIdentifierInterface) => Promise<ItemIdentifier>; deleteIdentifier: (identifierId: number) => Promise<void>; } => ({
    createIdentifier: async (item: Pick<Item, 'id'>, payload: createIdentifierInterface): Promise<ItemIdentifier> => {
        const body: CreateInventoryItemIdentifierRequest = {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- callers still pass free strings; the server's in: rule remains the validator
            identifier_type: payload.identifierType as CreateInventoryItemIdentifierRequest['identifier_type'],
            identifier: payload.identifier,
        };
        const response = await axios.post<CreateInventoryItemIdentifierResponse>(`/api/inventory/${item.id}/identifier`, body);
        return toItemIdentifier(response.data.identifier);
    },

    deleteIdentifier: async (identifierId: number): Promise<void> => {
        await axios.delete<DeleteInventoryItemIdentifierResponse>(`/api/identifier/${identifierId}`);
    },
});
